const VS = `attribute vec2 p; varying vec2 vUv;
void main(){ vUv = p * 0.5 + 0.5; gl_Position = vec4(p, 0.0, 1.0); }`;

const FS = `precision highp float;
uniform sampler2D uSrc; uniform sampler2D uSrcB; uniform sampler2D uLut; uniform sampler2D uFx; uniform sampler2D uPrev;
uniform float uMix; uniform float uDim; uniform float uT; uniform float uP; uniform float uUsePrev; uniform float uFinal;
uniform float uFxOn; uniform float uN; uniform float uSplit;
uniform float uMode; uniform float uAlpha; uniform vec2 uOff; uniform float uScale; uniform float uRot; uniform vec2 uRes;
uniform vec3 uKey; uniform float uSim; uniform float uSmooth; uniform float uSpill;
varying vec2 vUv;
vec3 lut(vec3 c){
  float n = uN; float b = c.b * (n - 1.0); float b0 = floor(b); float b1 = min(b0 + 1.0, n - 1.0); float f = b - b0;
  float x = c.r * (n - 1.0) + 0.5; float y = (c.g * (n - 1.0) + 0.5) / n;
  vec3 s0 = texture2D(uLut, vec2((x + b0 * n) / (n * n), y)).rgb;
  vec3 s1 = texture2D(uLut, vec2((x + b1 * n) / (n * n), y)).rgb;
  return mix(s0, s1, f);
}
vec3 A(vec2 uv){ return texture2D(uSrc, uv).rgb; }
vec3 B(vec2 uv){ return texture2D(uSrcB, uv).rgb; }
vec3 base(){
  float p = uP; vec2 uv = vUv;
  if (uT < 0.5) return mix(A(uv), B(uv), uMix) * uDim;
  if (uT < 1.5) return uv.x > 1.0 - p ? B(uv) : A(uv);
  if (uT < 2.5) return uv.x < p ? B(uv) : A(uv);
  if (uT < 3.5) return uv.x >= 1.0 - p ? B(vec2(uv.x - 1.0 + p, uv.y)) : A(vec2(uv.x + p, uv.y));
  if (uT < 4.5) return uv.x < p ? B(vec2(uv.x + 1.0 - p, uv.y)) : A(vec2(uv.x - p, uv.y));
  float env = 1.0 - abs(1.0 - 2.0 * p);
  if (uT < 5.5) return mix(p < 0.5 ? A(uv) : B(uv), vec3(1.0, 0.949, 0.82), env);
  vec2 q = vec2(uv.x, 1.0 - uv.y);
  if (uT < 6.5) {
    float cx = -0.2 + 1.4 * p;
    float g = env * (0.35 + 1.6 * exp(-((q.x - cx) * (q.x - cx) * 4.0 + (q.y - 0.3) * (q.y - 0.3) * 2.0)));
    return min(mix(A(uv), B(uv), p) + g * vec3(1.0, 0.62, 0.22), 1.0);
  }
  if (uT < 7.5) {
    float cx = -0.3 + 1.6 * p, d = q.x - cx + (q.y - 0.5) * 0.35;
    float g = env * (0.25 + 0.9 * exp(-d * d * 60.0) + 0.8 * exp(-((q.x - cx) * (q.x - cx) * 3.0 + (q.y - 0.5) * (q.y - 0.5) * 40.0)));
    return min(mix(A(uv), B(uv), p) + g * vec3(0.75, 0.88, 1.0), 1.0);
  }
  float dx = q.x - 0.5, dy = q.y - 0.5, r2 = dx * dx + dy * dy;
  float ray = pow(0.5 + 0.5 * cos(8.0 * atan(dy, dx)), 8.0);
  float g = env * env * (0.3 + 1.4 * exp(-r2 * 6.0) + 0.9 * ray * exp(-r2 * 2.5));
  return min((p < 0.5 ? A(uv) : B(uv)) + g * vec3(1.0, 0.93, 0.75), 1.0);
}
vec2 cbcr(vec3 c){ return vec2(dot(c, vec3(-0.169, -0.331, 0.5)), dot(c, vec3(0.5, -0.419, -0.081))); }
void main(){
  vec3 c = uUsePrev > 0.5 ? texture2D(uPrev, vUv).rgb : base();
  if (uFxOn > 0.5) {
    vec2 p = (vUv - 0.5) * uRes - uOff * uRes * 0.5;
    float cs = cos(uRot), sn = sin(uRot);
    vec2 l = vec2(cs * p.x - sn * p.y, sn * p.x + cs * p.y) / (uRes * uScale) + 0.5;
    if (l.x >= 0.0 && l.x <= 1.0 && l.y >= 0.0 && l.y <= 1.0) {
      vec3 f = texture2D(uFx, l).rgb;
      if (uMode < 0.5) { f = clamp((f - 0.15) / 0.85, 0.0, 1.0) * uAlpha; c = 1.0 - (1.0 - c) * (1.0 - f); }
      else if (uMode < 1.5) {
        float m = smoothstep(uSim, uSim + max(uSmooth, 0.001), distance(cbcr(f), cbcr(uKey)));
        if (uKey.g >= uKey.b) f.g = mix(f.g, min(f.g, max(f.r, f.b)), uSpill); else f.b = mix(f.b, min(f.b, max(f.r, f.g)), uSpill);
        c = mix(c, f, m * uAlpha);
      } else c = mix(c, f, uAlpha);
    }
  }
  gl_FragColor = vec4(uFinal < 0.5 ? c : vUv.x < uSplit ? c : lut(clamp(c, 0.0, 1.0)), 1.0);
}`;

export const TRANS_CODE = { dissolve: 0, dip: 0, wipeleft: 1, wiperight: 2, slideleft: 3, slideright: 4, flash: 5, leak: 6, flare: 7, starburst: 8 };

function compile(gl, type, src) {
  const s = gl.createShader(type);
  gl.shaderSource(s, src);
  gl.compileShader(s);
  return s;
}

function makeTex(gl) {
  const t = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, t);
  [gl.TEXTURE_WRAP_S, gl.TEXTURE_WRAP_T].forEach((k) => gl.texParameteri(gl.TEXTURE_2D, k, gl.CLAMP_TO_EDGE));
  [gl.TEXTURE_MIN_FILTER, gl.TEXTURE_MAG_FILTER].forEach((k) => gl.texParameteri(gl.TEXTURE_2D, k, gl.LINEAR));
  return t;
}

const makeTargets = (gl) => [0, 1].map(() => ({ tex: makeTex(gl), fb: gl.createFramebuffer(), w: 0, h: 0 }));

function sizeTarget(gl, t, w, h) {
  if (t.w === w && t.h === h) return;
  gl.activeTexture(gl.TEXTURE5);
  gl.bindTexture(gl.TEXTURE_2D, t.tex);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, w, h, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
  gl.bindFramebuffer(gl.FRAMEBUFFER, t.fb);
  gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, t.tex, 0);
  t.w = w; t.h = h;
}

export function createRenderer(canvas) {
  const gl = canvas.getContext("webgl", { preserveDrawingBuffer: true });
  if (!gl) return null;
  const prog = gl.createProgram();
  gl.attachShader(prog, compile(gl, gl.VERTEX_SHADER, VS));
  gl.attachShader(prog, compile(gl, gl.FRAGMENT_SHADER, FS));
  gl.linkProgram(prog);
  gl.useProgram(prog);
  const buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
  const loc = gl.getAttribLocation(prog, "p");
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
  const srcTex = makeTex(gl), lutTex = makeTex(gl), fxTex = makeTex(gl), srcBTex = makeTex(gl);
  const targets = makeTargets(gl);
  [["uSrc", 0], ["uLut", 1], ["uFx", 2], ["uSrcB", 3], ["uPrev", 4]].forEach(([n, u]) => gl.uniform1i(gl.getUniformLocation(prog, n), u));
  const U = Object.fromEntries(["uN", "uSplit", "uFxOn", "uMix", "uDim", "uT", "uP", "uUsePrev", "uFinal", "uMode", "uAlpha", "uOff", "uScale", "uRot", "uRes", "uKey", "uSim", "uSmooth", "uSpill"]
    .map((n) => [n, gl.getUniformLocation(prog, n)]));
  const upload = (unit, tex, src) => {
    gl.activeTexture(unit);
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, src); return true; } catch (_) { return false; }
  };
  const setLayer = (layer) => {
    const on = layer && upload(gl.TEXTURE2, fxTex, layer.el) ? 1 : 0;
    gl.uniform1f(U.uFxOn, on);
    if (!on) return;
    const p = layer.p;
    gl.uniform1f(U.uMode, { screen: 0, chroma: 1, normal: 2 }[p.blend] ?? 0);
    gl.uniform1f(U.uAlpha, p.alpha);
    gl.uniform2f(U.uOff, p.x, p.y);
    gl.uniform1f(U.uScale, Math.max(0.05, p.scale));
    gl.uniform1f(U.uRot, (p.rot * Math.PI) / 180);
    const k = p.key.match(/\w\w/g).map((x) => parseInt(x, 16) / 255);
    gl.uniform3f(U.uKey, k[0], k[1], k[2]);
    gl.uniform1f(U.uSim, p.sim); gl.uniform1f(U.uSmooth, p.smooth); gl.uniform1f(U.uSpill, p.spill);
  };

  return {
    setLut(data, N) {
      gl.activeTexture(gl.TEXTURE1);
      gl.bindTexture(gl.TEXTURE_2D, lutTex);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, N * N, N, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
      gl.uniform1f(U.uN, N);
    },
    clear() {
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.clearColor(0, 0, 0, 1);
      gl.clear(gl.COLOR_BUFFER_BIT);
    },
    draw(view, split = 0, layers = []) {
      const source = view.a;
      const w = source.videoWidth || source.naturalWidth || source.width, h = source.videoHeight || source.naturalHeight || source.height;
      if (!w || !h) return;
      const scale = Math.min(1, 1920 / w);
      const cw = Math.round(w * scale), ch = Math.round(h * scale);
      if (canvas.width !== cw || canvas.height !== ch) { canvas.width = cw; canvas.height = ch; }
      if (!upload(gl.TEXTURE0, srcTex, source)) return;
      const hasB = view.b && upload(gl.TEXTURE3, srcBTex, view.b);
      gl.uniform1f(U.uMix, hasB ? view.mix || 0 : 0);
      gl.uniform1f(U.uDim, view.dim ?? 1);
      gl.uniform1f(U.uT, hasB ? view.t || 0 : 0);
      gl.uniform1f(U.uP, view.p || 0);
      gl.uniform2f(U.uRes, cw, ch);
      gl.uniform1f(U.uSplit, split);
      const passes = Math.max(1, layers.length);
      gl.viewport(0, 0, cw, ch);
      for (let i = 0; i < passes; i++) {
        const last = i === passes - 1, out = targets[i % 2], prev = targets[(i + 1) % 2];
        if (!last) sizeTarget(gl, out, cw, ch);
        gl.activeTexture(gl.TEXTURE4);
        gl.bindTexture(gl.TEXTURE_2D, i > 0 ? prev.tex : null);
        gl.bindFramebuffer(gl.FRAMEBUFFER, last ? null : out.fb);
        gl.uniform1f(U.uUsePrev, i > 0 ? 1 : 0);
        gl.uniform1f(U.uFinal, last ? 1 : 0);
        setLayer(layers[i]);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      }
    },
  };
}
